import './previewbar.css';
import { useContext, useEffect, useState } from 'react';
import { UserContext, UserInfoContext } from '../../context';
import { restoreSupportSession, subscribeToSupportAdmin } from '../../modules/support-session';

export default function PreviewBar() {
  const userInfo = useContext(UserInfoContext);
  const user = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [supportAdmin, setSupportAdmin] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => subscribeToSupportAdmin(setSupportAdmin), []);

  if (!supportAdmin || !user || supportAdmin.uid === user.uid) {
    return null;
  }

  const revertToSuperAdmin = async () => {
    if (loading) return;
    setLoading(true);
    setErrorMessage('');
    try {
      await restoreSupportSession();
    } catch (error) {
      console.error('Error reverting back to super admin:', error);
      setErrorMessage('Kunne ikke skifte tilbage. Prøv igen. Hvis din adgang er ændret, skal du logge ind igen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`preview-bar ${loading ? 'preview-bar--loading' : ''}`}
      onClick={revertToSuperAdmin}
      role="button"
      tabIndex={0}
      aria-disabled={loading}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          revertToSuperAdmin();
        }
      }}
    >
      {errorMessage ? <span role="alert">{errorMessage}</span> : <>
        Du er logget ind som {userInfo.email || user.email}. Tryk her for at skifte tilbage til
        super admin.
      </>}
    </div>
  );
}
